import React from 'react';
import { Box } from '@mui/material';
import BestPostCardDetails from '../summary-cards/bestPostCard';

const MultiplePostCard = ({ posts }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row', // Arrange cards horizontally
        flexWrap: 'wrap', // Allow cards to wrap to the next line
        gap: 1.5,

      }}
    >
      {posts?.map((data, index) => (
        <Box
          key={index}
          sx={{
            maxWidth: 350, // Constrain individual card width for smaller size
            width: '100%', // Ensure responsiveness
            flexShrink: 0, // Prevent cards from shrinking too much
          }}
        >
          <BestPostCardDetails
            title={data?.title}
            comments={data?.comment_count}
            createdTime={data?.created_time}
            description={data?.description}
            engagement={data?.engagement}
            engagementRate={data?.engagement_rate}
            mediaUrl={data?.media_url}
            link={data?.link}
            reactions={data?.reaction}
            shares={data?.share_count}
            reach={data?.reach}
            saved={data?.saved}
          />
        </Box>
      ))}
    </Box>
  );
};

export default MultiplePostCard